import React from 'react';
import '../../css/about.css';

const DMCA = () => {
  return (
    <div className="about-page">
      <section className="about-section">
        <div className="container">
          <h1>DMCA &amp; Copyright Policy</h1>
          <p><em>Last updated: May 14, 2026</em></p>

          <h2>Overview</h2>
          <p>
            UnsupervisedBias respects the intellectual property rights of others and expects users of our
            platform to do the same. In accordance with the Digital Millennium Copyright Act of 1998
            ("DMCA"), we will respond promptly to notices of alleged copyright infringement that are
            reported to our designated copyright agent.
          </p>

          <h2>Reporting Copyright Infringement</h2>
          <p>
            If you believe that content on UnsupervisedBias infringes your copyright, please send a
            written notice to our designated agent containing all of the following:
          </p>
          <ul>
            <li>
              A physical or electronic signature of the copyright owner or a person authorized to act on
              their behalf.
            </li>
            <li>
              Identification of the copyrighted work claimed to have been infringed. If multiple works are
              covered by a single notification, a representative list of such works.
            </li>
            <li>
              Identification of the material that is claimed to be infringing or to be the subject of
              infringing activity, and information reasonably sufficient to permit us to locate the
              material (e.g., the URL of the page).
            </li>
            <li>
              Your contact information: name, mailing address, telephone number, and email address.
            </li>
            <li>
              A statement that you have a good faith belief that the use of the material in the manner
              complained of is not authorized by the copyright owner, its agent, or the law.
            </li>
            <li>
              A statement that the information in the notification is accurate, and under penalty of
              perjury, that you are authorized to act on behalf of the copyright owner.
            </li>
          </ul>

          <h2>Designated Copyright Agent</h2>
          <p>
            Please send DMCA notices to:
          </p>
          <p>
            <strong>UnsupervisedBias — Copyright Agent</strong><br />
            Washington, DC, USA<br />
            Email: <a href="mailto:legal@unsupervisedbias.com">legal@unsupervisedbias.com</a>
          </p>
          <p>
            Please include "DMCA Takedown Notice" in the subject line of your email.
          </p>

          <h2>Counter-Notification</h2>
          <p>
            If you believe that material you posted was removed or disabled by mistake or misidentification,
            you may submit a counter-notification to our designated agent. A valid counter-notification must
            include:
          </p>
          <ul>
            <li>Your physical or electronic signature.</li>
            <li>
              Identification of the material that has been removed or disabled, and the location at which
              the material appeared before it was removed or disabled.
            </li>
            <li>
              A statement under penalty of perjury that you have a good faith belief that the material was
              removed or disabled as a result of mistake or misidentification.
            </li>
            <li>
              Your name, address, telephone number, email address, and a statement that you consent to the
              jurisdiction of the federal district court for the judicial district in which your address is
              located, or if your address is outside the United States, for any judicial district in which
              UnsupervisedBias may be found, and that you will accept service of process from the person
              who provided the original DMCA notification.
            </li>
          </ul>
          <p>
            Upon receipt of a valid counter-notification, we will restore the removed content within
            10–14 business days unless we receive notice that a court action has been filed seeking an
            order restraining the subscriber from engaging in the infringing activity.
          </p>

          <h2>Repeat Infringer Policy</h2>
          <p>
            In appropriate circumstances, UnsupervisedBias will disable and/or terminate the accounts of
            users who are found to be repeat infringers. We consider a repeat infringer to be any user who
            has been notified of infringing activity more than twice or has had their content removed from
            our platform more than twice.
          </p>

          <h2>Third-Party Content</h2>
          <p>
            UnsupervisedBias may display or link to third-party content for informational purposes.
            We do not claim ownership of such content. All trademarks, logos, and brand names are the
            property of their respective owners. Any content from third-party sources is used under fair
            use or with the appropriate license.
          </p>
          <p>
            In particular, AI-generated articles on this platform may reference publicly available news
            and analysis. We make no claim of ownership over source material and include proper attribution
            where applicable.
          </p>

          <h2>Fair Use</h2>
          <p>
            Nothing in this policy is intended to restrict your rights under the fair use doctrine (17 U.S.C.
            § 107) or any other applicable limitation or exception to copyright law.
          </p>

          <h2>Modifications</h2>
          <p>
            UnsupervisedBias reserves the right to modify this policy at any time. Changes will be
            effective immediately upon posting to this page. Your continued use of our services after any
            such changes constitutes your acceptance of the new policy.
          </p>

          <h2>Contact Us</h2>
          <p>
            For general questions about this policy or our copyright practices, please contact us at{' '}
            <a href="mailto:legal@unsupervisedbias.com">legal@unsupervisedbias.com</a>.
          </p>
        </div>
      </section>
    </div>
  );
};

export default DMCA;
